import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";

const invoiceCommentsBasePath = (invoiceId: string) => `/invoices/${invoiceId}/comments`;

export function createInvoiceComment(invoiceId: string, text: string): AxiosApiResponsePromise<void> {
	return axiosApi.post(invoiceCommentsBasePath(invoiceId), { text });
}

export function updateInvoiceComment(invoiceId: string,
	invoiceCommentId: string,
	text: string): AxiosApiResponsePromise<void> {
	return axiosApi.put(invoiceCommentsBasePath(invoiceId) + "/" + invoiceCommentId, { text });
}

export function deleteInvoiceComment(invoiceId: string, invoiceCommentId: string): AxiosApiResponsePromise<void> {
	return axiosApi.delete(invoiceCommentsBasePath(invoiceId) + "/" + invoiceCommentId);
}